var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { PeekToggleButtonGroup, theme, PeekToggleButton, PeekStack } from "@piiqtechnologies/ui-components";
import CustomSubtitle from "./CustomSubtitle";
import { Field } from "formik";
export const PolicySelector = ({ label, policyOptions, field, form, }) => {
    const isSelected = (value) => {
        var _a, _b;
        if (((_a = field.value) === null || _a === void 0 ? void 0 : _a.length) !== value.length)
            return false;
        return (_b = field.value) === null || _b === void 0 ? void 0 : _b.every((value) => value.includes(value));
    };
    return (React.createElement(PeekStack, { spacing: 0.5 },
        React.createElement(CustomSubtitle, { subtitle: label }),
        React.createElement(PeekToggleButtonGroup, { color: "primary", value: null, exclusive: true, orientation: "horizontal", onChange: (_event, value) => {
                //@ts-ignore
                form.setFieldValue(field.name, value);
            }, sx: {
                maxWidth: "100%",
                overflow: "auto",
                scrollbarWidth: "thin",
                ".MuiButtonBase-root": {
                    whiteSpace: "nowrap !important",
                    height: 32,
                    fontSize: theme.typography.body1.fontSize,
                    borderColor: `${theme.palette.grey[200]} !important`,
                    boxShadow: "none !important",
                    borderWidth: 0.6,
                    "&:first-child": {
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                    },
                    "&:last-child": {
                        borderTopRightRadius: 8,
                        borderBottomRightRadius: 8,
                    },
                    ":not(:first-child)": {
                        marginLeft: -0.3,
                    },
                },
                ".Mui-selected": {
                    color: `${theme.palette.success.main} !important`,
                    borderColor: `${theme.palette.success.main} !important`,
                    backgroundColor: `${theme.palette.grey[50]} !important`,
                    zIndex: 2,
                },
            } }, policyOptions.map(({ value, label }) => (React.createElement(PeekToggleButton, { key: label, value: value, selected: isSelected(value), sx: { width: "100%", fontSize: `${theme.typography.body1.fontSize}px !important` } }, label))))));
};
export const PolicySelectorField = (_a) => {
    var { id } = _a, props = __rest(_a, ["id"]);
    return (React.createElement(Field, Object.assign({ id: id, key: id, name: id, component: PolicySelector }, props)));
};
